<template>
  <div id="kpi" style="height: 100%; width: 100%">
    <div id="sel" style="height: 10%; width: 100%">
      <el-select
        v-model="selectedBU"
        style="right: -20px"
        placeholder="所有BU"
        @change="refreshPlantList()"
      >
        <el-option
          v-for="item in BUList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>

      <el-select
        id="selectedPlant"
        v-model="selectedPlant"
        multiple
        filterable
        clearable
        placeholder="所有工厂"
      >
        <el-option
          v-for="item in PlantList"
          :key="item.PlantCode"
          :label="item.PlantName"
          :value="item.PlantCode"
        ></el-option>
      </el-select>

      <el-button-group>
        <el-button
          :type="activeChartGroup == 'chart' ? 'primary' : 'success'"
          plain
          :disabled="activeChartGroup == 'chart'"
          icon="el-icon-s-data"
          @click="onChartGroupChanged('chart')"
        ></el-button>
        <el-button
          :type="activeChartGroup == 'table' ? 'primary' : 'success'"
          plain
          :disabled="activeChartGroup == 'table'"
          icon="el-icon-s-grid"
          @click="onChartGroupChanged('table')"
        ></el-button>
        <el-button
          :type="activeChartGroup == 'detail' ? 'primary' : 'success'"
          plain
          :disabled="activeChartGroup == 'detail'"
          icon="el-icon-document"
          @click="onChartGroupChanged('detail')"
        ></el-button>
      </el-button-group>

      <el-date-picker
        v-model="selectedDateRange"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
      ></el-date-picker>
      <el-input
        v-model="FilterNumber"
        style="width: 80px"
        placeholder="前N"
      ></el-input>
      <el-button type="success" plain @click="loadDataList()">查询</el-button>
    </div>
    <div style="width: 100%; height: 85%">
      <el-col :span="12">
        <div id="chartKpi1" style="width: 950px; height: 850px"></div>
      </el-col>
      <el-col :span="12">
        <div id="chartKpi2" style="width: 950px; height: 850px"></div>
      </el-col>
    </div>
  </div>
</template>

<script>
// 2：导入echarts
import echarts from "echarts";
import topHeader from "../TopMenu/topHeader.vue";
import request from "@/utils/request";
import { AREA_LIST, BU_LIST } from "../mainPage/area_bu";
export default {
  name: "kpi1",
  data() {
    return {
      activeName: "first",
      PageTitle: "搪塑线对标",
      DataList: {},
      PlantList: [],
      datasetDe: [],
      datasetPL: [],
      AreaList: AREA_LIST,
      BUList: BU_LIST,
      selectedArea: "GLOBAL",
      selectedBU: "",
      selectedPlant: "",
      selectedBranch: "",
      selectedTon: "",
      selectedEquipment: "",
      selectedDateRange: "",
      selectedFilterBy: "",
      activeChartGroup: "chart",
      activeCategory: "rate",
      activeColumnGroup: "energy",
      selectedFilterOrder: "desc",
      FilterNumber: "10",
      FilterListCategory: {
        kpi: [
          { value: "kpi_minute", label: "分钟单耗" },
          { value: "kpi_kg", label: "公斤单耗" },
          { value: "kpi_mold", label: "模单耗" },
        ],
        rate: [
          { value: "rate_cost", label: "能源利用率" },
          { value: "rate_time", label: "时间利用率" },
        ],
        pvf: [
          { value: "pvf_peak", label: "峰时占比" },
          { value: "pvf_flat", label: "平时占比" },
          { value: "pvf_valley", label: "谷时占比" },
          { value: "pvf_avg_cost", label: "均价" },
        ],
      },
      FilterOrder: [
        { value: "desc", label: "从大到小" },
        { value: "asc", label: "从小到大" },
      ],
      // 需要合并对象，样式
      legendColor: false,
      mm: 5,
      dataset: [],
      dataLabel: [],
      equipDesc: [],
      shadowBar: [],
    };
  },
  created() {},
  mounted() {
    //   mounted 函数表示已经DOM渲染完成
    const { loadDataList, refreshDataOnChange, refreshPlantList } = this;
    var day1 = new Date();
    day1.setDate(1);
    var day2 = new Date();
    //day2.setTime(day2.getTime()-24*60*60*1000)
    this.selectedDateRange = [day1, day2];

    // this.selectedFilterBy = this.FilterListCategory[this.activeCategory][0].value
    loadDataList();
  },
  methods: {
    refreshPlantList() {
      const { loadDataList, refreshDataOnChange } = this;

      let selBu = "";
      if (this.selectedBU !== undefined && this.selectedBU !== "") {
        //selBu = this.selectedBU.join()
        selBu = this.selectedBU;
      }
      const queryArgs = {
        QueryAreaName: this.selectedArea,
        QueryBU: selBu,
        QueryFilterBy: "IsUpload",
      };
      request({
        url: "Kanban/PlantList",
        method: "post",
        data: queryArgs,
      }).then((response) => {
        const res = response;
        console.log(res);
        this.PlantList = res.data.Data.PlantList;
      });
    },
    //加载数据
    loadDataList() {
      const { formatDate } = this;

      let selBu = "";
      if (this.selectedBU !== undefined && this.selectedBU !== "") {
        //selBu = this.selectedBU.join()
        selBu = this.selectedBU;
      }
      let selPlant = "";
      if (this.selectedPlant !== undefined && this.selectedPlant !== "") {
        selPlant = this.selectedPlant.join();
      }
      let selEquip = "";
      if (
        this.selectedEquipment !== undefined &&
        this.selectedEquipment !== ""
      ) {
        selEquip = this.selectedEquipment.join();
      }
      const queryArgs = {
        QueryAreaName: this.selectedArea,
        QueryBU: selBu,
        QueryPlantCode: selPlant,
        QueryManufacturerType: this.selectedBranch,
        QueryTonnageType: this.selectedTon,
        QueryEquipment: selEquip,
        QueryFilterBy: this.selectedFilterBy,
        QueryOrderAsc: this.selectedFilterOrder,
        QueryFilterOrder: this.FilterNumber,
        QueryDataCategory: this.activeCategory,
        QueryDetailData: this.activeChartGroup == "detail" ? "Y" : "",
      };
      if (
        this.selectedDateRange != undefined &&
        this.selectedDateRange.length > 1
      ) {
        queryArgs.QueryStartMonth = formatDate(this.selectedDateRange[0]);
        queryArgs.QueryEndMonth = formatDate(this.selectedDateRange[1]);
      }

      request({
        url: "Kanban/plasticining_DataList",
        method: "post",
        data: queryArgs,
      }).then((response) => {
        const res = response;
        this.DataList = res.data.Data;
        console.log("搪塑数据", res.data);
        console.log("搪塑数据2", response);
        console.log("搪塑数据3", this.DataList);
        //    this.loadUpData(this.DataList);
        this.refreshChart(this.DataList);
        this.refreshKpi2(this.DataList);
      });
    },
    formatDate(date) {
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      if (m < 10) m = "0" + m;
      var d = date.getDate();
      if (d < 10) d = "0" + d;
      var s = y + "-" + m + "-" + d;
      return s;
    },
    refreshKpi2(va) {
      //var serColorsKPI = ["#1E90FF", "#008B45", "#99d0b9", "#8E8E38", "#6aa36a"];
      var that = this;
      var data = va;
      var Dedata1 = [];
      var Dedata2 = [];
      var Dedata3 = [];
      var Dedata4 = [];

      var Pldata1 = [];
      var Pldata2 = [];
      var Pldata3 = [];
      var Pldata4 = [];
      console.log("this", data);
      const serColors = ["#008B45", "#1E90FF", "#8E8E38", "#6aa36a"];
      var DeLS = data[2].kpiGroupDate;
      var PlLS = data[2].kpiGroupPlan;
      // var mb = data[2].bb;
      for (var i = 0; i < DeLS.length; i++) {
        Dedata1.push(DeLS[i].DateX);
        Dedata2.push(DeLS[i].EnergyValueByMold);
        Dedata3.push(DeLS[i].EnergyValueByMinutes);
        Dedata4.push(DeLS[i].EnergyValueByKG);
      }

      for (var i = 0; i < PlLS.length; i++) {
        Pldata1.push(PlLS[i].PlanId);
        Pldata2.push(PlLS[i].EnergyValueByMold);
        Pldata3.push(PlLS[i].EnergyValueByMinutes);
        Pldata4.push(PlLS[i].EnergyValueByKG);
      }
      // console.log("data1",data1);
      // console.log("data2",data2);
      // console.log("data3",data3);
      // console.log("ma",ma);
      // console.log("mb",mb);

      var data = [Dedata1, Dedata2, Dedata3, Dedata4];
      // this.datasetPL = [Pldata1, Pldata2, Pldata3, Pldata4];
      console.log(data[0]);

      var myChartKpi2 = echarts.init(document.getElementById("chartKpi2"));
      myChartKpi2.clear();

      // var zoomConfig = []
      // if (data1.length > 8) {
      //   zoomConfig.push({ type: 'inside', start: 0, end: 8 / data1.length * 100 })
      // }

      var option = {
        title: {
          text: "注塑机KPI对比",
          textStyle: {
            color: "#fff",
            fontSize: 24,
          },
          x: 50,
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
          formatter: function (params) {
            var str = "";
            str += params[0].name;
            //str += '<br/>' + that.equipDesc[params[0].dataIndex]
            str += "<br/>";
            var now = new Date();
            for (var i = 0; i < params.length; i++) {
              str += "<br/>" + params[i].seriesName + ":" + params[i].value;
            }
            return str;
          },
        },
        legend: {
          data: ["分钟单耗", "公斤单耗", "模单耗"],
          x: "right",
          textStyle: {
            color: "#fff",
            fontSize: 16,
          },
        },
        grid: {
          left: "6%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: data[0],
            axisTick: {
              alignWithLabel: true,
              interval: 0,
            },
            axisLabel: {
              interval: 0,
              color: "#fff",
              fontSize: 16,
            },
            axisLine: {
              // 轴线
              lineStyle: {
                color: "#7f8fa4",
              },
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            boundaryGap: [0, "10%"],
            axisLabel: {
              color: "#fff",
              fontSize: 16,
            },
            splitLine: {
              show: false,
            },
            axisLine: {
              lineStyle: {
                color: "#7f8fa4",
              },
            },
          },
        ],
        //dataZoom: zoomConfig,
        series: [
          {
            name: "分钟单耗",
            type: "line",
            data: data[2],
            color: serColors[0],
            xAxisIndex: 0,
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  position: "top",
                  textStyle: {
                    color: "#fff",
                    fontSize: 14,
                  },
                },
              },
            },
            symbol: "diamond",
          },
          {
            name: "公斤单耗",
            type: "line",
            data: data[3],
            color: serColors[1],
            xAxisIndex: 0,
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  position: "top",
                  textStyle: {
                    color: "#fff",
                    fontSize: 14,
                  },
                },
              },
            },
            symbol: "diamond",
          },
          {
            name: "模单耗",
            type: "line",
            data: data[1],
            color: serColors[2],
            xAxisIndex: 0,
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  position: "top",
                  textStyle: {
                    color: "#fff",
                    fontSize: 14,
                  },
                },
              },
            },
            symbol: "diamond",
          },
        ],
      };
      // 5：展示数据
      myChartKpi2.setOption(option);
    },
    refreshChart(va) {
      //var serColorsKPI = ["#1E90FF", "#008B45", "#99d0b9", "#8E8E38", "#6aa36a"];
      var that = this;
      var data = va;
      var Dedata1 = [];
      var Dedata2 = [];
      var Dedata3 = [];
      var Dedata4 = [];

      var Pldata1 = [];
      var Pldata2 = [];
      var Pldata3 = [];
      var Pldata4 = [];
      console.log("this", data);
      const serColors = ["#008B45", "#1E90FF", "#8E8E38", "#6aa36a"];
      var DeLS = data[2].kpiGroupDate;
      var PlLS = data[2].kpiGroupPlan;
      // var mb = data[2].bb;
      for (var i = 0; i < DeLS.length; i++) {
        Dedata1.push(DeLS[i].DateX);
        Dedata2.push(DeLS[i].EnergyValueByMold);
        Dedata3.push(DeLS[i].EnergyValueByMinutes);
        Dedata4.push(DeLS[i].EnergyValueByKG);
      }

      for (var i = 0; i < PlLS.length; i++) {
        Pldata1.push(PlLS[i].PlanId);
        Pldata2.push(PlLS[i].EnergyValueByMold);
        Pldata3.push(PlLS[i].EnergyValueByMinutes);
        Pldata4.push(PlLS[i].EnergyValueByKG);
      }
      // console.log("data1",data1);
      // console.log("data2",data2);
      // console.log("data3",data3);
      // console.log("ma",ma);
      // console.log("mb",mb);

      this.datasetDe = [Dedata1, Dedata2, Dedata3, Dedata4];
      this.datasetPL = [Pldata1, Pldata2, Pldata3, Pldata4];
      var myChart = echarts.init(document.getElementById("chartKpi1"));
      myChart.clear();

      // var zoomConfig = [];
      // var iZoomLength = 8;
      // if (data1.length > iZoomLength) {
      //   zoomConfig.push(
      //     {
      //       type: "slider",
      //       show: true,
      //       realtime: true,
      //       start: 0,
      //       end: (iZoomLength / data1.length) * 100,
      //     },
      //     {
      //       type: "inside",
      //       show: true,
      //       realtime: true,
      //       start: 0,
      //       end: (iZoomLength / data1.length) * 100,
      //     }
      //   );
      // }

      var option = {
        title: {
          text: "注塑机KPI对比",
          textStyle: {
            color: "#fff",
            fontSize: 24,
          },
          left: "center",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
          formatter: function (params) {
            var str = "";
            str += params[0].name;
            str += "<br/>" + that.equipDesc[params[0].dataIndex];
            str += "<br/>";
            var now = new Date();
            for (var i = 0; i < params.length; i++) {
              str += "<br/>" + params[i].seriesName + ":" + params[i].value;
            }
            return str;
          },
        },
        legend: {
          data: ["分钟单耗", "公斤单耗", "模单耗"],
          x: "right",
          textStyle: {
            color: "#fff",
            fontSize: 16,
          },
        },
        grid: {
          x: 25,
          y: 25,
          x2: 5,
          y2: 20,
          top: "100px",
          bottom: "15px",
          borderWidth: 1,
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: this.datasetPL[0],
            axisTick: {
              alignWithLabel: true,
              interval: 0,
            },
            axisLabel: {
              interval: 0,
              color: "#fff",
              fontSize: 12,
            },
            axisLine: {
              // 轴线
              lineStyle: {
                color: "#7f8fa4",
              },
            },
          },
        ],
        yAxis: [
          {
            name: "kWh",
            type: "value",
            nameTextStyle: {
              color: "#fff",
              fontSize: 16,
            },
            boundaryGap: [0, "10%"],
            axisLabel: {
              color: "#fff",
              fontSize: 16,
            },
            splitLine: {
              show: false,
            },
            axisLine: {
              lineStyle: {
                color: "#7f8fa4",
              },
            },
          },
        ],
        // dataZoom: zoomConfig,
        series: [
          {
            name: "分钟单耗",
            type: "bar",
            data: this.datasetPL[1],
            color: serColors[0],
            xAxisIndex: 0,
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  position: "top",
                  textStyle: {
                    color: "#fff",
                    fontSize: 14,
                  },
                },
              },
            },
          },
          {
            name: "公斤单耗",
            type: "bar",
            data: this.datasetPL[2],
            color: serColors[1],
            xAxisIndex: 0,
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  position: "top",
                  textStyle: {
                    color: "#fff",
                    fontSize: 14,
                  },
                },
              },
            },
          },
          {
            name: "模单耗",
            type: "bar",
            data: this.datasetPL[3],
            color: serColors[2],
            xAxisIndex: 0,
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  position: "top",
                  textStyle: {
                    color: "#fff",
                    fontSize: 14,
                  },
                },
              },
            },
          },
        ],
      };
      // 5：展示数据
      myChart.setOption(option);
    },
  },
};
</script>

<style lang="less" scoped >
#kpi {
  position: relative;
  width: 100%;
  background-color: #1b2445;
  height: 100%;
  box-sizing: border-box;
  .box {
    position: relative;
    width: 100%;
    height: 100%;
  }
  element.style {
    width: 100%;
  }
}
</style>
